import React, { useEffect, useState, ChangeEvent, useRef } from 'react'

export const useEdit = (value: string, onSave?: (value: string) => void) => {
  const [inputValue, setInputValue] = useState(value)
  const [isEnabled, setIsEnabled] = useState(false)
  const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null)

  const handleSave = () => {
    if (!isEnabled) {
      inputRef.current?.focus()
      return
    }

    // onBlur performs the save
    inputRef.current?.blur()
  }

  const onSaveMouseDown = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault()
  }

  const onFocus = () => setIsEnabled(true)

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setInputValue(e.target.value)
  }

  const onBlur = () => {
    onSave?.(inputValue.trim())
    setIsEnabled(false)
  }

  // Only adopt an incoming value while idle, so it can't reset what is being typed
  useEffect(() => {
    if (isEnabled) return
    if (value === inputValue) return
    setInputValue(value)
  }, [value, isEnabled])

  return {
    isEnabled,
    value: inputValue,
    onChange,
    onFocus,
    onBlur,
    onSave: handleSave,
    onSaveMouseDown,
    inputRef,
  }
}
